import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import { C } from "@/brand/tokens";

const COLORS = { teal: C.accentFunctional, brass: C.accentMetal, light: C.textOnDark, ink: C.textOnLight };

/**
 * TextLink6 — directional text link with arrow ("Explore HR & People Consulting →").
 * Use as="span" when nested inside a card that is already a Link.
 */
export function TextLink6({ to, href, as, children, testId, tone = "teal", className = "", external, onClick }) {
  const props = {
    "data-testid": testId,
    className: `group inline-flex items-center gap-2 font-inter text-[11px] uppercase font-semibold transition-colors ${className}`,
    style: { color: COLORS[tone] || COLORS.teal, letterSpacing: "0.2em" },
    onClick,
  };
  const inner = (
    <>
      {children}
      <ArrowRight size={11} weight="bold" className="transition-transform group-hover:translate-x-1" />
    </>
  );
  if (as === "span") return <span {...props}>{inner}</span>;
  if (to) return <Link to={to} {...props}>{inner}</Link>;
  return (
    <a href={href} target={external ? "_blank" : undefined} rel={external ? "noreferrer" : undefined} {...props}>
      {inner}
    </a>
  );
}
